const getLiteralText = (value, items) => {
  const item = items.find((item2) => item2.value === value);
  return item?.title;
};
export {
  getLiteralText
};
//# sourceMappingURL=get-literal-text.js.map
